import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { Analytics } from '@vercel/analytics/react';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import BasePage from './pages/BasePage';
import Welcome from './components/welcome';
import Join from './components/join';
import Services from './components/services';
import Contact from './components/contact';
import About from './components/about';


const root = ReactDOM.createRoot(document.getElementById('root'));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#c4b397",
      contrastText: "#ffffff"
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          lineHeight: 0
        }
      }
    }
  },
});

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route index element={<BasePage><Welcome /></BasePage>} />
          <Route path="/map" element={<><ScrollToTop /> <App /></>} />
          <Route path="/ga-med" element={<BasePage><Join /></BasePage>} />
          <Route path="/vara-tjanster" element={<BasePage><Services /></BasePage>} />
          <Route path="/kontakta-oss" element={<BasePage><Contact /></BasePage>} />
          <Route path="/om-oss" element={<BasePage><About /></BasePage>} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
    <Analytics />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
